import { navigateTo } from '#app'

export default defineNuxtRouteMiddleware(async (to) => {
  if (!to.path.startsWith('/admin')) return

  if (to.path === '/admin/login') return

  let user: any = null

  try {
    if (import.meta.server) {
      const headers = useRequestHeaders(['cookie'])
      const requestFetch = useRequestFetch()
      user = await requestFetch('/api/admin/auth/me', { headers })
    } else {
      user = await $fetch('/api/admin/auth/me')
    }
  } catch {
    return navigateTo('/admin/login')
  }

  // Agentes só podem acessar páginas de atendimento
  if (user && user.role === 'agent') {
    const allowedPaths = ['/admin/atendimentos', '/admin/atendimento-detalhes']
    const isAllowed = allowedPaths.some(path => to.path.startsWith(path))
    if (!isAllowed) {
      return navigateTo('/admin/atendimentos')
    }
  }

  return
})
